module.exports = __webpack_public_path__ + "img/scene3.10a19f08.png";